import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M6 0h4v4h6v4h-6v4H6V8H0V4h6V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          d="M9.004 2.403H9V5h3.553V4.97l.88-.498v2.98L12.6 7H9v2.523h.004l.479.88h-2.98L7 9.523V7H3.386l-.833.453v-2.98l.88.498V5H7V2.4l-.497-.877h2.98l-.479.88Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
